const MerchantServicesAddServiceLaunch = props => {
  return (
    <>
      <h1>Add Service - Launch</h1>
    </>
  )
}

export default MerchantServicesAddServiceLaunch;